import { apiAuth, apiResponseType } from ".";

export const getLogsData = (
  page: number = 1,
  filters = {}
): apiResponseType => {
  const queryParams = new URLSearchParams();
  queryParams.append("page", page.toString());

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryParams.append(key, value.toString());
    }
  });

  return apiAuth.get(`logs?${queryParams.toString()}`);
};

export const searchLogsData = (params: {
  route?: string;
  method?: string;
  user_id?: number;
  type?: string;
  status_code?: number;
  date_start?: string;
  date_end?: string;
}): apiResponseType => {
  const queryParams = new URLSearchParams();
  
  if (params?.route) {
    queryParams.append("route", params.route);
  }
  
  if (params?.method) {
    queryParams.append("method", params.method);
  }
  
  if (params?.user_id) {
    queryParams.append("user_id", params.user_id.toString());
  }
  
  if (params?.type) {
    queryParams.append("type", params.type);
  }
  
  if (params?.status_code) {
    queryParams.append("status_code", params.status_code.toString());
  }
  
  if (params?.date_start) {
    queryParams.append("date_start", params.date_start);
  }
  
  if (params?.date_end) {
    queryParams.append("date_end", params.date_end);
  }
  
  return apiAuth.get(`logs?${queryParams.toString()}`);
};

export const getLogDetail = (uuid: string): apiResponseType => {
  return apiAuth.get(`logs/${uuid}/show`);
}; 